import contentful from "libraries/contentful/client";
import { sendContentfulRequest } from 'services/server/contentful/ContentfulApi'

export async function getStoriesMatchingSearchString(searchString: string) {
  const entries = await sendContentfulRequest(
    "entries",
    `content_type=story&include=10&fields.author.fields.fullName[match]=${searchString}`
  );
  return entries;
}

export async function getStoryBySlug(storySlug: string) {
  const entries = await contentful.getEntries({ content_type: "story", "fields.slug": storySlug });
  const [storyEntry] = [...(entries?.items ?? [])]
  return storyEntry;
}

export async function getStoryById(storyId: string) {
  const entries = await contentful.getEntries({
    content_type: "story",
    "sys.id": storyId
  });
  const [storyEntry] = [...(entries?.items ?? [])];
  return storyEntry;
}